import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonCircleQuestion, faEarthAmericas } from '@fortawesome/free-solid-svg-icons';
import CustomHook from './CustomHook';

// images of projects

function Projects() {
  const [listProjects] = useState([
    {
      deployLink: 'https://next-pizza-v2.vercel.app/',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Next-Pizza-v2',
      name: 'Next Pizza v2',
      des: '🍕 Developing a Dodo pizza clone store on Next.js 🍕',
      mission: 'Fullstack Store created by next js app router here you can buy pizza by yookassa',
      language: 'HTML5, NextJS, React JS, Tailwind, Prisma, Zustand',
      images:
        'https://i.ytimg.com/vi/GUwizGbY4cc/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLCoC7sCh9QiyVMg88cJSluZplNckw',
      secondButton: false,
    },
    {
      deployLink: 'https://next-pizza-sigma.vercel.app/',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Next-Pizza/',
      name: 'Next Pizza',
      des: 'This made by Next js and modern redux toolkit fast app you can buy pizza, order it and finally eat.',
      mission: 'Delivery pizza store created to buy and order pizza',
      language: 'HTML5, CSS3, SCSS, React JS, Next JS, Redux Toolkit',
      images: '/next-pizza-image.png',
      secondButton: true,
    },
    {
      deployLink: 'https://hamster-kombat-sable.vercel.app/',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Hamster-Kombat-Clone',
      name: 'Hamster Komat Clone',
      des: 'This is popular NFT telegram app hamster komat clone',
      mission: 'Click and earn points',
      language: 'HTML5, CSS3, Tailwind, React JS',
      images: '/hamster.jpg',
    },
    {
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Todo-List-App',
      name: 'Todo List App',
      des: 'This is todo list app with own database',
      mission: 'Here you can add and edit, delete tasks',
      language: 'HTML5, CSS3, Next JS, React JS, DB-JSON',
      images: '/todolist.jpg',
      secondButton: true,
    },
    {
      deployLink: 'https://general-chat.vercel.app/',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/General-Chat-UI',
      gitHubLinkBackend: 'https://github.com/Gevork-Sarkisyan222/General-Chat-Server',
      name: 'General Chat',
      des: 'Here you can chat with your friends in real time because i use socket io.',
      mission: 'Chat with members of group ask advices, tell something here',
      language: 'HTML5, CSS3, SCSS, React JS, Node JS, MongoDB, Socket IO',
      images: '/General Chat - Google Chrome 31.05.2024 18_45_04.png',
    },
    {
      deployLink: 'https://instagram-best-clone.vercel.app/',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Instagram-Clone-UI',
      gitHubLinkBackend: 'https://github.com/Gevork-Sarkisyan222/Instagram-Clone-Backend',
      name: 'Instagram Clone',
      des: 'You can create your own posts, add friends chat with them like in real instagram.',
      mission: 'FullStack social media prototype, analog of real Instagram but much better',
      language: 'HTML5, CSS3, SCSS, React JS, Nest JS, MongoDB, Socket IO',
      images:
        'https://res.cloudinary.com/practicaldev/image/fetch/s--7M9GwxEO--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/xavdbzb40k2xvr42wy57.PNG',
    },
    {
      deployLink: 'https://find-job-resumes-app.vercel.app/',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Find-Job-App-UI',
      gitHubLinkBackend: 'https://github.com/Gevork-Sarkisyan222/Nest-JS-First-Server',
      name: 'Find Job App',
      des: 'You can create your own posts, add friends chat with them like in real instagram.',
      mission: 'Find your job here, stop lying on the couch create your resume here',
      language: 'HTML5, CSS3, SCSS, React JS, Nest JS, MongoDB',
      images: '/find-job-image.png',
      secondButton: true,
    },
    {
      deployLink: 'https://gevork-sarkisyan222.github.io/Gallery-Redux-Store/#/Gallery-Redux-Store',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Gallery-Redux-Store',
      name: 'Gallery-Redux-Store',
      des: 'This is my first project made to learn the redux toolkit here you can order famous pictures or create your.',
      mission: 'Frontend Store created to but pictures and create it',
      language: 'HTML5, CSS3, React JS, Redux Toolkit',
      images:
        'https://firebasestorage.googleapis.com/v0/b/instagram-clone-4c00a.appspot.com/o/1Gallery%20Store%20_%20%D0%9B%D1%83%D1%87%D1%88%D0%B8%D0%B9%20%D0%BC%D0%B0%D0%B3%D0%B0%D0%B7%D0%B8%D0%BD%20%D0%BA%D0%B0%D1%80%D1%82%D0%B8%D0%BD%D0%BE%D0%BA%20-%20Google%20Chrome%2010.03.2024%2017_52_13.png?alt=media&token=95212aa1-f687-4406-a108-5e4ce1d1b041',
    },
    {
      deployLink: 'https://responsive-layout-brown.vercel.app/',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Responsive-Layout',
      name: 'Responsive Layout',
      des: 'You can create your own posts, add friends chat with them like in real instagram.',
      mission: 'Responsive app created by flex',
      language: 'HTML5, CSS3, SCSS, Flex, React JS',
      images: '/responsive-image.png',
      secondButton: true,
    },
    {
      deployLink: 'https://bike-store-xi.vercel.app/',
      gitHubLinkClient: 'https://github.com/Gevork-Sarkisyan222/Bike-Store',
      name: 'Bike Store',
      des: 'You can create your own posts, add friends chat with them like in real instagram.',
      mission: 'Responsive app created by flex and grid',
      language: 'HTML5, CSS3, SCSS, Grid, Flex, React JS',
      images: '/bike-store-image.png',
    },
  ]);
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);

  const goToLink = (url) => {
    window.open(url, '_blank');
  };

  return (
    <section className="projects" ref={scrollTab}>
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        This is my Projects
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}>
        {/* 20 */}
        My list of projects that i build by vercel & gh-pages open them and explore also you can
        open it in github and see the source code.
      </div>
      <div className="list">
        {listProjects.map((value, key) => (
          <div className="item" key={key} ref={(el) => el && divs.current.push(el)}>
            <div className="images">
              <img src={value.images} alt="" />
            </div>
            <div className="content">
              <h3>{value.name}</h3>
              <div className="des">{value.des}</div>
              <div className="mission">
                <div>
                  <FontAwesomeIcon icon={faPersonCircleQuestion} />
                </div>
                <div>
                  <h4>Mission</h4>
                  <div className="des">{value.mission}</div>
                </div>
              </div>
              <div className="mission">
                <div>
                  <FontAwesomeIcon icon={faEarthAmericas} />
                </div>
                <div>
                  <h4>Languages</h4>
                  <div className="des">{value.language}</div>
                </div>
              </div>
              <div className="buttons-section">
                {value.deployLink && (
                  <button
                    onClick={() => goToLink(value.deployLink)}
                    class={`glowbutton ${value.secondButton && 'purple'}`}>
                    Open
                  </button>
                )}
                {value.gitHubLinkClient && (
                  <div class="button-icon">
                    <div class="icon">
                      <svg viewBox="0 0 24 24">
                        <path
                          d="M12 0.296997C5.37 0.296997 0 5.67 0 12.297C0 17.6 3.438 22.097 8.205 23.682C8.805 23.795 9.025 23.424 9.025 23.105C9.025 22.82 9.015 22.065 9.01 21.065C5.672 21.789 4.968 19.455 4.968 19.455C4.422 18.07 3.633 17.7 3.633 17.7C2.546 16.956 3.717 16.971 3.717 16.971C4.922 17.055 5.555 18.207 5.555 18.207C6.625 20.042 8.364 19.512 9.05 19.205C9.158 18.429 9.467 17.9 9.81 17.6C7.145 17.3 4.344 16.268 4.344 11.67C4.344 10.36 4.809 9.29 5.579 8.45C5.444 8.147 5.039 6.927 5.684 5.274C5.684 5.274 6.689 4.952 8.984 6.504C9.944 6.237 10.964 6.105 11.984 6.099C13.004 6.105 14.024 6.237 14.984 6.504C17.264 4.952 18.269 5.274 18.269 5.274C18.914 6.927 18.509 8.147 18.389 8.45C19.154 9.29 19.619 10.36 19.619 11.67C19.619 16.28 16.814 17.295 14.144 17.59C14.564 17.95 14.954 18.686 14.954 19.81C14.954 21.416 14.939 22.706 14.939 23.096C14.939 23.411 15.149 23.786 15.764 23.666C20.565 22.092 24 17.592 24 12.297C24 5.67 18.627 0.296997 12 0.296997Z"
                          fill="#222229"></path>
                      </svg>
                    </div>
                    <div class="cube">
                      <span class="side front">Source client code</span>
                      <span onClick={() => goToLink(value.gitHubLinkClient)} class="side top">
                        check it on github
                      </span>
                    </div>
                  </div>
                )}
                {value?.gitHubLinkBackend && (
                  <div class="button-icon">
                    <div class="icon">
                      <svg viewBox="0 0 24 24">
                        <path
                          d="M12 0.296997C5.37 0.296997 0 5.67 0 12.297C0 17.6 3.438 22.097 8.205 23.682C8.805 23.795 9.025 23.424 9.025 23.105C9.025 22.82 9.015 22.065 9.01 21.065C5.672 21.789 4.968 19.455 4.968 19.455C4.422 18.07 3.633 17.7 3.633 17.7C2.546 16.956 3.717 16.971 3.717 16.971C4.922 17.055 5.555 18.207 5.555 18.207C6.625 20.042 8.364 19.512 9.05 19.205C9.158 18.429 9.467 17.9 9.81 17.6C7.145 17.3 4.344 16.268 4.344 11.67C4.344 10.36 4.809 9.29 5.579 8.45C5.444 8.147 5.039 6.927 5.684 5.274C5.684 5.274 6.689 4.952 8.984 6.504C9.944 6.237 10.964 6.105 11.984 6.099C13.004 6.105 14.024 6.237 14.984 6.504C17.264 4.952 18.269 5.274 18.269 5.274C18.914 6.927 18.509 8.147 18.389 8.45C19.154 9.29 19.619 10.36 19.619 11.67C19.619 16.28 16.814 17.295 14.144 17.59C14.564 17.95 14.954 18.686 14.954 19.81C14.954 21.416 14.939 22.706 14.939 23.096C14.939 23.411 15.149 23.786 15.764 23.666C20.565 22.092 24 17.592 24 12.297C24 5.67 18.627 0.296997 12 0.296997Z"
                          fill="#222229"></path>
                      </svg>
                    </div>
                    <div class="cube">
                      <span class="side front">Source backend code</span>
                      <span onClick={() => goToLink(value?.gitHubLinkBackend)} class="side top">
                        check it on github
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
export default Projects;
